import { useCallback, useMemo, useRef, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import type { NavItem } from '../../lib/navigation'
import { idOngletDePage, ongletCourant } from '../../lib/ongletsDePage'
import { OngletsDeLaPageContext } from '../../contexts/OngletsDeLaPageContext'
import { BarreOngletsSuivie } from './OngletsDeLEntree'

/**
 * Spec 161 (D-161-07) — une page réunie sous une entrée de menu à onglets : la page en panneau (`tabpanel`), et la barre
 * d'onglets de l'entrée.
 *
 * Second retour de Christophe sur `dev` (2026-10-12) : la barre se place **sous le titre** de la page, comme sur
 * « Échéances et budget ». La page la pose elle-même (`OngletsDeLEntree`) sous son en-tête et le signale ; tant
 * qu'aucune ne l'a signalée, la barre reste posée ici, en tête de page — une page qui l'oublierait garde ses onglets.
 */
export function PageAOnglets({ entree, idPanneau, children }: { entree: NavItem; idPanneau: string; children: ReactNode }) {
  const { pathname } = useLocation()
  const [poseesParLaPage, setPoseesParLaPage] = useState(0)
  const signaler = useCallback((delta: 1 | -1) => setPoseesParLaPage(n => n + delta), [])
  const focusAReprendre = useRef(false)
  const contexte = useMemo(() => ({ entree, idPanneau, signaler, focusAReprendre }), [entree, idPanneau, signaler])
  return (
    <OngletsDeLaPageContext.Provider value={contexte}>
      {poseesParLaPage === 0 && <BarreOngletsSuivie entree={entree} idPanneau={idPanneau} dansLaPage={false} />}
      <div role="tabpanel" id={idPanneau} aria-labelledby={idOngletDePage(entree, ongletCourant(entree, pathname))}>
        {children}
      </div>
    </OngletsDeLaPageContext.Provider>
  )
}
